import { Injectable } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import jwt_decode from "jwt-decode";
import { DataService } from "./data.service";

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    public router: Router,
    public dataService: DataService,
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let authToken: any = this.dataService.getToken();

    if (!authToken) {
      this.router.navigate(["/pages/login"]);
      return false;
    }
    const res = this.validateToken(authToken);

    if (!res) {
      this.router.navigate(["/pages/login"]);
      return false;
    }

    const userType = localStorage.getItem("user_type");

    if (!userType) {
      localStorage.clear();
      this.router.navigate(["/pages/login"]);
      return false;
    }

    // The only source of truth for what a logged-in user can open is the
    // `authorized_urls` list computed at login from their actual menu
    // privileges (see login.component.ts) - no route is hardcoded here.
    const authorizedUrls: string[] =
      JSON.parse(localStorage.getItem("authorized_urls")) ?? [];

    const requestedUrl = state.url?.split("?")[0];
    const isAllowed = authorizedUrls.some(
      (url) => requestedUrl === url || requestedUrl.startsWith(url + "/"),
    );

    // if (!isAllowed) {
    //   // Redirecting to "/" would re-enter this same guarded route tree via
    //   // the default-route redirect in app.routing.ts, and if the stored
    //   // default route is itself missing/stale/unauthorized that becomes an
    //   // immediate infinite navigate loop (each pass re-printing this log
    //   // thousands of times and pegging the CPU). Only redirect to the
    //   // default route when it's actually authorized, and never redirect to
    //   // the URL we're already denying - fall back to the (unguarded) login
    //   // route so the loop can't reconstitute itself.
    //   const defaultUrl = localStorage.getItem("default_url");
    //   const isDefaultUrlSafe =
    //     !!defaultUrl &&
    //     defaultUrl !== requestedUrl &&
    //     authorizedUrls.some(
    //       (url) => defaultUrl === url || defaultUrl.startsWith(url + "/"),
    //     );
    //   const fallbackUrl = isDefaultUrlSafe ? defaultUrl : "/pages/login";

    //   console.log(
    //     `unauthorized route '${requestedUrl}' Redirecting to ${fallbackUrl}`,
    //   );
    //   this.router.navigate([fallbackUrl]);
    // return false;
    // }

    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  validateToken(authToken) {
    try {
      const decodedToken: any = jwt_decode(authToken);
      // console.log('decodedToken-------------->', decodedToken)
      if (decodedToken.exp === undefined) {
        return false;
      }

      const expTime = decodedToken.exp;
      if (expTime.valueOf() < Date.now() / 1000) {
        return false;
      }

      return true;
    } catch (err) {
      // console.log('token err: ', err);
      return false;
    }
  }
}
